import React, { useEffect, useRef, useState } from 'react'
import { FileText as FileTextIcon } from 'react-feather'
import { Dialog, Typography, Button, Box, Link } from '@material-ui/core'

import useRegulations from 'hooks/useRegulations'

import helpers from 'helpers'

import useStyles from './styles'
import theme from 'theme'

const RegulationAcceptanceDialog = ({ open }) => {
  const classes = useStyles()
  const { regulationVersions, acceptRegulation, isAccept, isLoading } =
    useRegulations()

  const paperRef = useRef(null)
  const [remountKey, setRemountKey] = useState(0)

  const isOpen = open && !isAccept && !isLoading

  const regulationVersion = regulationVersions?.[0]
  const firstAcceptance = Boolean(regulationVersion?.firstAcceptance)
  const startsAt =
    helpers.formatters.dates.ptBrFormatDate(regulationVersion?.startsAt) ||
    'Indefinido'

  const title = firstAcceptance
    ? `Documento "${regulationVersion?.regulation?.title}"`
    : `Atualização "${regulationVersion?.regulation?.title}"`

  const description = firstAcceptance
    ? `Para continuar, é necessário ler e aceitar o documento "${regulationVersion?.regulation?.title}", da plataforma.`
    : `Informamos que o documento "${regulationVersion?.regulation?.title}", da plataforma, foi atualizado, com vigência a partir de ${startsAt}.`

  const handleAcceptRegulation = () => acceptRegulation(regulationVersion?.id)

  useEffect(() => {
    if (!isOpen) return undefined

    const observer = new MutationObserver(() => {
      if (paperRef.current && !paperRef.current.isConnected) {
        setRemountKey((previousKey) => previousKey + 1)
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })

    return () => observer.disconnect()
  }, [isOpen, remountKey])

  return (
    <Dialog
      key={remountKey}
      open={isOpen}
      disableEscapeKeyDown
      maxWidth="sm"
      style={{ zIndex: 10000 }}
      BackdropProps={{ classes: { root: classes.backdrop } }}
      PaperProps={{ ref: paperRef }}
    >
      <Box className={classes.content}>
        <Box display="flex" alignItems="center" gridGap={theme.spacing(2)}>
          <Box className={classes.iconWrapper}>
            <FileTextIcon size={20} />
          </Box>
          <Typography variant="h5">{title}</Typography>
        </Box>
        <Typography variant="h6">{description}</Typography>
        <Typography>{regulationVersion?.message}</Typography>
        <Typography>
          A versão integral do documento está disponível&nbsp;
          <Typography
            component={Link}
            href={regulationVersion?.url}
            underline="always"
            target="_blank"
            rel="noopener noreferrer"
            variant="h6"
          >
            aqui.
          </Typography>
        </Typography>
        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            onClick={handleAcceptRegulation}
            disabled={isAccept}
          >
            Estou ciente
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}

export default RegulationAcceptanceDialog
